(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-sticky"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('mainNavbar');
      this.headerBounds = {};
      this.currentScrollTop = 110;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('d-none', 'fixed-top');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('d-block', 'fixed-top', 'animate');
      this.header.classList.remove('d-none');
    }

    reset() {
      this.header.classList.remove('d-block', 'fixed-top', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    

  function setVariant(sellingPlanId="") {
    var variantId = Number(sectionEle.querySelector('input[name="id"]').value);
    var variant = getCurrentVariant( variantId );

    sectionEle.querySelector("input[name=selling_plan]").value = sellingPlanId;
    
    if( sellingPlanId ) {
      var sellingPlan = variant.selling_plan_allocations[0];
      var totalSavings = Math.floor( Math.abs( (sellingPlan.price - sellingPlan.compare_at_price) / (sellingPlan.compare_at_price) * 100) );
      jQuery('.product-price').text( Shopify.formatMoney( sellingPlan.price ) );
      sectionEle.querySelector('.product-price-compare strike').innerText = Shopify.formatMoney( sellingPlan.compare_at_price );
      sectionEle.querySelector('.product-price-savings span').innerText = totalSavings + "% OFF";
      sectionEle.querySelector('.product-price-compare').classList.remove("d-none");
      sectionEle.querySelector('.product-price-savings').classList.remove("d-none");
      sectionEle.querySelector('.one-time-message').classList.add("d-none");

      /* If addon exists, update to first option */
      if( sectionEle.querySelector("input[name=addon]") ){
        sectionEle.querySelector("input[name=addon]").checked = true;
      };
    } else {
      jQuery('.product-price').text( Shopify.formatMoney( variant.price ) );
      sectionEle.querySelector('.product-price-compare').classList.add("d-none");
      sectionEle.querySelector('.product-price-savings').classList.add("d-none");
      sectionEle.querySelector('.one-time-message').classList.remove("d-none");

      /* If addon exists, update 'pay today' price */
      if( sectionEle.querySelector('input[name="addon"]:checked').value ) {
        var addonPrice = Number(sectionEle.querySelector('input[name="addon"]:checked').dataset.price);
        sectionEle.querySelector('.price-box .product-price').innerText = Shopify.formatMoney( variant.price + addonPrice );
      }
    };

  };

  function getCurrentVariant( variantId ) {
    var variants = featuredProduct.variants;
    // map variants and return the selected one
    var found = jQuery.map(variants, function(variant) {
      if(variant.id == variantId) {
        return variant; // return matching variant object
      }
    });
    return found[0]; // returns single array so pull out first element object
  };
  
  /* Change selling plan based on group selected */
  var sellingPlanChoices = [].slice.call(sectionEle.querySelectorAll('input[name="selling_plan_choice"]'));
  var sellingPlan = sellingPlanChoices.map(function (ele) {
    ele.addEventListener("change",function(evt) {
      var sellingPlanId = Number(evt.target.value);
      setVariant( sellingPlanId );
    });
  });

  /* Change addon based on group selected */
  var addOnChoices = [].slice.call(sectionEle.querySelectorAll('input[name="addon"]'));
  var addOn = addOnChoices.map(function (ele) {
    ele.addEventListener("change",function(evt) {
      setVariant();
    });
  });

  sectionEle.querySelector('input[name="selling_plan_onetime"]').addEventListener("change",function(evt) {
    var sellingPlanId = "";
    var sellingPlanCollapse = new bootstrap.Collapse('#subscriptionPlan');

    if( evt.target.checked == true ) {
      sellingPlanCollapse.hide();
    } else {
      sellingPlanId = defaultSellingPlanId;
      sectionEle.querySelector('input[value="'+sellingPlanId+'"]').checked = true;
      sellingPlanCollapse.show();
    }
    setVariant( sellingPlanId );
  });

  sectionEle.querySelector('form[action="cart/add"]').addEventListener("submit", function(evt) {
    evt.preventDefault();

    sectionEle.querySelector('button[type="submit"]').innerText = "Processing...";
    
    var formData = new FormData(evt.target);
    var formProps = Object.fromEntries(formData);
    var itemsToAdd = [];
    itemsToAdd.push( { id: formProps['id'], quantity:1, selling_plan:formProps['selling_plan'] } );

    if(formProps['addon'].length > 1 ){
      var addon = formProps['addon'].split(':');
      itemsToAdd.push({ 'id': addon[0], 'quantity':Number(addon[1]) });
    };
    
    var itemFormData = { 'items': itemsToAdd };

    Shopify.clear( function() {
      setTimeout(function() {
        Shopify.addItemFromData(itemFormData, function(data){
          if(formProps["return_to"] == "checkout") {
            window.location.href = '/checkout';
          }
        });
      }, 1000);
      
    });
  
  });

  setVariant( document.querySelector('input[name="selling_plan_choice"]:checked').value );

  jQuery('#quantity').inputSpinner();

  if( jQuery('#mip-carousel div.carousel-hero div').length > 1 ) {
    jQuery('#mip-carousel div.carousel-hero').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: 'ondemand',
      touchMove: true,
      asNavFor: jQuery('#mip-carousel').data('slider-nav'),
      arrows: jQuery('#mip-carousel').data('slider-arrows'),
      dots: jQuery('#mip-carousel').data('slider-dots'),
    });
    
    jQuery('#mip-carousel div.carousel-nav').not('.slick-initialized').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.carousel-hero',
      focusOnSelect: true
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    
var product = JSON.parse(document.getElementById('ProductJson').innerHTML);

function setVariant(sellingPlanId = "") {
  var variantId = Number(document.querySelector('input[name="id"]').value);
  var variant = getCurrentVariant(variantId);

  // Update the hidden input that Shopify uses for the cart
  document.querySelector("input[name=selling_plan]").value = sellingPlanId;

  if (sellingPlanId) {
    // SUBSCRIPTION LOGIC
    var sellingPlan = variant.selling_plan_allocations.find(function(alloc) {
      return alloc.selling_plan_id == sellingPlanId;
    }) || variant.selling_plan_allocations[0];

    var totalSavings = Math.floor(Math.abs((sellingPlan.price - sellingPlan.compare_at_price) / (sellingPlan.compare_at_price) * 100));
    
    document.querySelectorAll('.product-price').forEach(el => {
      el.innerText = Shopify.formatMoney(sellingPlan.price);
    });
    document.querySelectorAll('.product-price-compare strike').forEach(el => {
      el.innerText = Shopify.formatMoney(sellingPlan.compare_at_price);
    });
    document.querySelectorAll('.product-price-savings span').forEach(el => {
      el.innerText = totalSavings + "% OFF";
    });
    
    document.querySelectorAll('.product-price-compare').forEach(el => el.classList.remove("d-none"));
    document.querySelectorAll('.product-price-savings').forEach(el => el.classList.remove("d-none"));
    document.querySelectorAll('.one-time-message').forEach(el => el.classList.add("d-none"));

    if (document.querySelector("input[name=addon]")) {
      document.querySelector("input[name=addon]").checked = true;
    };
  } else {
    // ONE-TIME PURCHASE LOGIC
    document.querySelectorAll('.product-price').forEach(el => {
      el.innerText = Shopify.formatMoney(variant.price);
    });
    document.querySelectorAll('.product-price-compare').forEach(el => el.classList.add("d-none"));
    document.querySelectorAll('.product-price-savings').forEach(el => el.classList.add("d-none"));
    document.querySelectorAll('.one-time-message').forEach(el => el.classList.remove("d-none"));

    var addonCheck = document.querySelector('input[name="addon"]:checked');
    if (addonCheck && addonCheck.value !== "") {
      var addonPrice = Number(addonCheck.dataset.price);
      document.querySelectorAll('.price-box .product-price').forEach(el => {
        el.innerText = Shopify.formatMoney(variant.price + addonPrice);
      });
    }
  }
}

function getCurrentVariant(variantId) {
  return product.variants.find(function(v) { return v.id == variantId; });
}

/* --- MOBILE LISTENERS --- */
document.querySelectorAll('input[name="selling_plan_choice"]').forEach(function(ele) {
  ele.addEventListener("change", function(evt) {
    setVariant(Number(evt.target.value));
  });
});

document.querySelector('input[name="selling_plan_onetime"]').addEventListener("change", function(evt) {
  var sellingPlanId = "";
  var sellingPlanCollapse = new bootstrap.Collapse('#subscriptionPlan', { toggle: false });

  if (evt.target.checked) {
    sellingPlanCollapse.hide();
  } else {
    sellingPlanId = defaultSellingPlanId;
    document.querySelector('input[value="' + sellingPlanId + '"]').checked = true;
    sellingPlanCollapse.show();
  }
  setVariant(sellingPlanId);
});

/* --- DESKTOP LISTENERS --- */
var dSub = document.getElementById('desktop_sub');
var dOne = document.getElementById('desktop_onetime');
var dSelect = document.getElementById('desktop_frequency_select');

if (dSub && dOne && dSelect) {
  dSub.addEventListener('change', function() { if(this.checked) setVariant(dSelect.value); });
  dOne.addEventListener('change', function() { if(this.checked) setVariant(""); });
  dSelect.addEventListener('change', function() { if(dSub.checked) setVariant(this.value); });
}

/* --- ADDONS & QUANTITY --- */
document.querySelectorAll('input[name="addon"]').forEach(function(ele) {
  ele.addEventListener("change", function() { setVariant(""); });
});

/* var qtySelector = document.getElementById('qtySelect');
if(qtySelector) {
  document.getElementById('qtySelect').addEventListener("change",function(evt) {
    document.querySelector('[name="quantity"]').value = evt.target.value;
  });   
} */

document.querySelectorAll('#qtySelect, #qtySelectDesktop').forEach(function(sel){
  sel.addEventListener("change", function(evt) {
    document.querySelector('[name="quantity"]').value = evt.target.value;
  });
});

/* --- FORM SUBMISSION --- */
document.getElementById('ProductAddToCart').addEventListener("submit", function(evt) {
  evt.preventDefault();
  document.querySelector('button[type="submit"]').innerText = "Processing...";
  
  var formData = new FormData(evt.target);
  var formProps = Object.fromEntries(formData);
  var itemsToAdd = [{ 
    id: formProps['id'], 
    quantity: formProps['quantity'], 
    selling_plan: formProps['selling_plan'] 
  }];

  if (formProps['addon']) {
    var addon = formProps['addon'].split(':');
    itemsToAdd.push({ 'id': addon[0], 'quantity': Number(addon[1]) });
  }

  Shopify.clear(function() {
    setTimeout(function() {
      Shopify.addItemFromData({ 'items': itemsToAdd }, function() {
        if (formProps["return_to"] == "checkout") window.location.href = '/checkout';
      });
    }, 1000);
  });
});

/* --- INITIALIZATION --- */
window.addEventListener('DOMContentLoaded', (event) => {
  var isDesktop = window.innerWidth >= 992; // Match your CSS breakpoint
  var initialId = "";

  if (isDesktop) {
    var dSub = document.getElementById('desktop_sub');
    var dSelect = document.getElementById('desktop_frequency_select');
    if (dSub && dSub.checked) {
      initialId = dSelect.value;
    }
  } else {
    var mobileChecked = document.querySelector('input[name="selling_plan_choice"]:checked');
    var oneTimeCheck = document.getElementById('singlePurchase');
    
    // If one-time is checked on mobile, ID stays empty string
    if (mobileChecked && (!oneTimeCheck || !oneTimeCheck.checked)) {
      initialId = mobileChecked.value;
    }
  }
  
  setVariant(initialId);
});

// Carousel Logic (unchanged)
if (jQuery('#mip-carousel div.carousel-hero div').length > 1) {
  jQuery('#mip-carousel div.carousel-hero').not('.slick-initialized').slick({
    slidesToShow: 1, slidesToScroll: 1, lazyLoad: 'ondemand', asNavFor: jQuery('#mip-carousel').data('slider-nav')
  });
  jQuery('#mip-carousel div.carousel-nav').not('.slick-initialized').slick({
    slidesToShow: 6, slidesToScroll: 1, asNavFor: '.carousel-hero', focusOnSelect: true
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendations);

      const url = productRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
		MiniCart.bindUIActions();
      })
      .catch(e => {
        console.error(e);
      });

    };

    const productRecommendations = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();
})();
